angular.module('numeration', ['ui.router'])
    .factory('Numeration', function ($resource) {
        return $resource('/crm/api/numeration/:doc/:operation', {}, {
            nextNumber: {method: 'GET', url: '/crm/api/numeration/next-number'}
        })
    })
    .controller('SettingsDocumentsCtrl', function (Numeration) {
        let vm = this
        vm.items = Numeration.query()
    })
    .config(function ($stateProvider) {
        $stateProvider.state('numerationList', {
            parent: 'app',
            url: '/settings/documents',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/settings/numeration.tpl.html',
                    controller: 'SettingsDocumentsCtrl',
                    controllerAs: 'vm'
                }
            }
        })
    })
